import React from "react";
import { Formik, Form, Field, useFormikContext } from "formik";
import * as Yup from "yup";
import { Settings } from "../../../helpers/Contexts";
import { MdClose, MdCheck } from "react-icons/md";

import FieldError from "../../../shared/FieldError";

const Weight = ({ data, handleField }) => {
  const WeightSchema = Yup.object().shape({
    data: Yup.string()
      .nullable()
      .min(2, "Minimum 2 number characters or more")
      .matches(/^\d*\.{1,2}\d*$/, "Weight must be a floating value e.g. 140.00"),
  });

  return (
    <div>
      <Formik
        initialValues={{
          data: data.value,
        }}
        validationSchema={WeightSchema}
        validateOnChange={true}
        onSubmit={async (values) =>
          await handleField({
            id: data.id,
            cpr_id: data.cprId,
            value: values.data,
            quality_measurement_type_id: data.quality_measurement_type_id,
          })
        }
      >
        {({ values, errors, setFieldValue, initialValues }) => {
          return (
            <Form>
              <label>
                Weight <span id="from">(weight in lbs)</span>
              </label>
              <input
                className="default"
                placeholder="e.g. 144.00"
                value={values.data}
                onChange={(e) => setFieldValue("data", e.target.value)}
              />
              {initialValues.data !== values.data && !errors.data && (
                <div className="check-cancel-buttons flex">
                  <button className="check small" type="submit">
                    <MdCheck className="check-icon" />
                  </button>
                  <button
                    className="cancel small"
                    onClick={() => {
                      initialValues.data
                        ? setFieldValue("data", initialValues.data)
                        : setFieldValue("data", "");
                    }}
                  >
                    <MdClose className="cancel-icon" />
                  </button>
                </div>
              )}
              {errors.data ? <FieldError error={errors.data} /> : null}
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default Weight;
